module.exports = __webpack_public_path__ + "img/document.9ec769bf.svg";